// removed by extract-text-webpack-plugin
module.exports = {"numberselect":"NumberSelect__numberselect___2tLJD","numberselect-button":"NumberSelect__numberselect-button___aXkvm","numberselect-indicator":"NumberSelect__numberselect-indicator___2feuO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/NumberSelect.css
// module id = 709
// module chunks = 0